// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"c26ad73f","127":"5b94f44b","626":"3cfaf594","739":"1a9fc00d","815":"3ea722f8"}[chunkId] + ".chunk.css";
};